module.exports = __webpack_public_path__ + "img/logo.d5deb66f.png";